import { MyOskPlatformSubscriptionOrderService } from '../../../api/api-services/my-osk-platform-subscription-order.service';
import { IPlatformSubscriptionsOrderIm } from '../../../api/platform-subscriptions-order-im.model';
import { IPlatformSubscriptionItemIm } from '../../../api/platform-subscription-item-im.model';
import { IInitialisedPaymentLinkVm } from '../../../api/initialised-payment-link-vm.model';
import { IMyOskSubscriptonsVm } from '../../../api/my-osk-subscriptons-vm.model';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPlatformSubscriptionPlanVm } from '../../../api/platform-subscription-plan-vm.model';

@Injectable({
  providedIn: 'root',
})
export class OskSubscriptionsService {
  private _myOskPlatformSubscriptionOrderService = inject(
    MyOskPlatformSubscriptionOrderService
  );

  oskSetSubscriptionPayment$(): Observable<IInitialisedPaymentLinkVm> {
    const payload: IPlatformSubscriptionsOrderIm = {
      platformSubscriptionItems: this.generatePlatformSubscriptionItems(),
    };

    return this._myOskPlatformSubscriptionOrderService.post(payload);
  }

  private generatePlatformSubscriptionItems(): IPlatformSubscriptionItemIm[] {
    let selectedSubscriptions: {
      subscriptionPlan: IPlatformSubscriptionPlanVm;
      quantity: number;
    }[] = this.getSelectedSubscriptionsFromLocalStorage();

    const platformSubscriptionItems: IPlatformSubscriptionItemIm[] =
      selectedSubscriptions.map(
        (plan: {
          subscriptionPlan: IPlatformSubscriptionPlanVm;
          quantity: number;
        }) => ({
          platformSubscriptionGuid: plan.subscriptionPlan.guid,
          itemsCount: plan.quantity,
        })
      );

    console.log(platformSubscriptionItems);

    return platformSubscriptionItems;
  }

  getSelectedSubscriptionsFromLocalStorage(): {
    subscriptionPlan: IPlatformSubscriptionPlanVm;
    quantity: number;
  }[] {
    const storedData = localStorage.getItem('selectedSubscriptions');
    if (storedData) {
      return JSON.parse(storedData);
    } else {
      return [];
    }
  }
}
